import axiosInstance from '../services/AxiosInstance';

export function getNotifications(pageNum = 1, pageSize = 10) {
    return axiosInstance.get(`notification?&pageNum=${pageNum}&pageSize=${pageSize}&orderBy=createdAt`);
}

export function readNotifications(notifications) {
    return axiosInstance.post('notification/read', {
        notifications,
    });
}

export function clearAllNotifications() {
    return axiosInstance.delete('notification', {
        data: {
            notifications: "all"
        }
    });
}
